import { useState, useEffect } from 'react'
import { useAuthContext } from '../providers/AuthProvider'

// УБРАЛИ ADMIN_IDS - теперь проверка только через backend API

export const useAdminCheck = () => {
    const { user, isAuthenticated } = useAuthContext()
    const [isAdmin, setIsAdmin] = useState(false)
    const [checking, setChecking] = useState(true)

    useEffect(() => {
        const check = async () => {
            if (!isAuthenticated || !user) {
                setIsAdmin(false)
                setChecking(false)
                return
            }

            // Проверяем через backend API (админские ID не светятся на клиенте)
            try {
                const { adminService } = await import(
                    '../services/adminService'
                )
                const response = await adminService.checkAdmin()
                setIsAdmin(response?.isAdmin || false)
            } catch (error) {
                // Если API вернул ошибку - значит не админ
                setIsAdmin(false)
            } finally {
                setChecking(false)
            }
        }

        check()
    }, [user, isAuthenticated])

    return { isAdmin, checking }
}
